export interface Props {
  fromPage?: "field" | "group" | "livestock" | "tags";
  isArchive?: boolean;
  groupId?: string;
  fieldId?: string;
  tagId?: string;
  showSelectColumn: boolean;
  showAnimalActionButtons: boolean;
  showIndividualAnimalActionButtons?: boolean;
  excludedFilters?: {
    groupId?: boolean;
    fieldId?: boolean;
  };
}

export enum PregnancyStatus {
  PREGNANT = "pregnant",
  NOTPREGNANT = "notPregnant",
}

export enum Sex {
  MALE = "M",
  FEMALE = "F",
}

export interface Filters {
  fieldId: string;
  groupId: string;
  sex: string;
  pregnancyStatus: string;
  dateOfBirth: {
    from: Date | undefined;
    to: Date | undefined;
  };
  dateOnFarm: {
    from: Date | undefined;
    to: Date | undefined;
  };
}
